"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieStorage = void 0;
var Cookies = require("js-cookie");
var object_utils_1 = require("../utils/object.utils");
var CookieStorage = /** @class */ (function () {
    function CookieStorage(config) {
        this.config = config;
        this.path = config.path;
        this.domain = config.domain;
        this.expires = config.expires;
        this.secure = config.secure;
    }
    CookieStorage.prototype.setItem = function (key, value) {
        if (value != null && value.length !== 0) {
            Cookies.set(key, value, {
                path: this.path,
                expires: this.expires,
                domain: this.domain,
                secure: this.secure
            });
            return this.getItem(key);
        }
        return value;
    };
    CookieStorage.prototype.getItem = function (key) {
        return object_utils_1.isEmpty(Cookies.get(key)) ? Cookies.get(key) : null;
    };
    CookieStorage.prototype.removeItem = function (key) {
        var removed = Cookies.remove(key, {
            path: this.path,
            domain: this.domain,
            secure: this.secure
        });
        return removed !== undefined ? true : false;
    };
    CookieStorage.prototype.clear = function () {
        var cookies = Cookies.get();
        var total = cookies.keys;
        var index;
        for (index = 0; index < Object.keys(cookies).length; ++index) {
            Cookies.remove(cookies[index]);
        }
        return {};
    };
    return CookieStorage;
}());
exports.CookieStorage = CookieStorage;
//# sourceMappingURL=cookie.storage.js.map